import { Tag } from 'iconsax-react';
import type { ReactNode } from 'react';
import GroupDefaultAvatarIcon from '@/assets/images/contact/group-default-avatar.svg?react';
import UserDefaultAvatarIcon from '@/assets/images/contact/user-default-avatar.svg?react';
import PinIcon from '@/assets/images/icons/pin.svg?react';
import RightIcon from '@/assets/images/icons/right.svg?react';
import { SafeImage } from '@/components/common/safe-image';
import cn from '@/utils/merge-class-names';

interface AvatarProps {
  className?: string;
  isOnline?: boolean;
  isSelf?: boolean;
  imageUrl: Nullable<string>;
  label?: string;
  isPin?: boolean;
  size?: [number, number];
  defaultAvatar?: 'user' | 'group' | 'tag';
  isFriend?: boolean;
}

export function AvatarWithStatus({
  size,
  isOnline,
  isSelf,
  className,
  imageUrl,
  isPin,
  defaultAvatar = 'user',
  isFriend = false,
}: AvatarProps) {
  let content: ReactNode = null;

  if (imageUrl) {
    content = (
      <SafeImage
        className='size-full rounded-full bg-base-100 bg-cover'
        src={imageUrl}
        size={size}
      />
    );
  } else if (defaultAvatar === 'user') {
    content = (
      <div className='rounded-full size-full !flex flex-center bg-neutral-0'>
        <UserDefaultAvatarIcon className='size-6 text-primary' />
      </div>
    );
  } else if (defaultAvatar === 'group') {
    content = (
      <div className='rounded-full size-full !flex flex-center bg-primary'>
        <GroupDefaultAvatarIcon className='size-5' />
      </div>
    );
  } else if (defaultAvatar === 'tag') {
    content = (
      <div className='rounded-full size-full !flex flex-center bg-metal-100'>
        <Tag
          variant='Bold'
          className='size-5 text-metal-500'
        />
      </div>
    );
  }

  return (
    <div
      className={cn('avatar aspect-square rounded-full before:bottom-[7%] before:top-0', className, {
        'ring-2 ring-offset-1 ring-secondary': isSelf === true,
      })}>
      {content}
      {isOnline && <div className='absolute bottom-0 right-0 size-2 rounded-full bg-green-500 ring ring-neutral-0' />}
      {isPin && (
        <div className='absolute top-0 right-0 size-2.5 rounded-full ring-2 ring-neutral-0 bg-primary p-0.25 text-white'>
          <PinIcon />
        </div>
      )}
      {isPin ||
        (isFriend && (
          <div className='absolute top-0 right-0 size-2.5 rounded-full ring-2 ring-neutral-0 bg-[#0a2fc0] p-0.25 text-white'>
            <RightIcon />
          </div>
        ))}
    </div>
  );
}
